import PropTypes from 'prop-types';

// utils
import cn from '@repo/zolintra-utils/cn';

import styles from './Tag.module.css';

export function Tag({
  children, color, size, action, actionSide, className,
}) {
  return (
    <div
      className={cn([
        styles.tag,
        styles[color],
        styles[size],
        action ? styles[actionSide] : '',
        className || '',
      ])}
    >
      <div className={styles.action}>{action}</div>
      <div className={styles.content}>{children}</div>
    </div>
  );
}

Tag.propTypes = {
  children: PropTypes.node.isRequired,
  color: PropTypes.oneOf(['primary', 'success', 'error']),
  size: PropTypes.oneOf(['small', 'medium']),
  action: PropTypes.node,
  actionSide: PropTypes.oneOf(['left', 'right']),
  className: PropTypes.string,
};

Tag.defaultProps = {
  color: 'primary',
  size: 'small',
  action: null,
  actionSide: 'left',
  className: null,
};

export default Tag;
